(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfm-ajustements"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const cible = (sec) => {
    const cls = sec.className || '';
    if (/header/i.test(cls)) return false;
    if (sec.id && /header/i.test(sec.id)) return false;
    return true;
  };

  const io = new IntersectionObserver((entrees) => {
    entrees.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('bfm-revealed');
      io.unobserve(e.target);
    });
  }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });

  const armer = () => {
    document.querySelectorAll('.shopify-section').forEach((sec) => {
      if (sec.dataset.bfmRevealArme || !cible(sec)) return;
      sec.dataset.bfmRevealArme = '1';
      sec.classList.add('bfm-reveal');
      const r = sec.getBoundingClientRect();
      // déjà visible au chargement : pas la peine d'attendre le scroll
      if (r.top < innerHeight * .9 && r.bottom > 0) {
        sec.classList.add('bfm-revealed');
      } else {
        io.observe(sec);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', armer);
  armer();
  document.addEventListener('shopify:section:load', armer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfm-barre-service"]) return;
  try {
    
(() => {
  const TZ = 'America/Toronto';
  const init = (root) => {
    if (root.dataset.pret) return;
    root.dataset.pret = '1';
    const cd = root.querySelector('[data-cd]');
    if (!cd) return;
    const tombee = Number(root.dataset.tombee || 13);
    const fermes = (root.dataset.fermes || '').split(',').map((x) => x.trim())
      .filter(Boolean).map(Number);
    const feries = (root.dataset.feries || '').split(',').map((x) => x.trim()).filter(Boolean);
    const eh = root.querySelector('[data-h]');
    const em = root.querySelector('[data-m]');
    const es = root.querySelector('[data-s]');
    const el = root.querySelector('[data-lab]');
    const deux = (n) => String(n).padStart(2, '0');
    const ymd = (d) => new Intl.DateTimeFormat('en-CA',
      {timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit'}).format(d);
    const secondes = () => {
      const f = new Intl.DateTimeFormat('en-CA', {timeZone: TZ, hour: '2-digit',
        minute: '2-digit', second: '2-digit', hour12: false}).formatToParts(new Date());
      const g = (t) => Number(f.find((p) => p.type === t).value);
      return (g('hour') % 24) * 3600 + g('minute') * 60 + g('second');
    };
    const ouvrable = (d) => !fermes.includes(new Date(ymd(d) + 'T12:00:00').getDay())
      && !feries.includes(ymd(d));
    const maj = () => {
      const sec = secondes();
      let restant;
      const meme = ouvrable(new Date()) && sec < tombee * 3600;
      if (meme) {
        restant = tombee * 3600 - sec;
      } else {
        let saut = 1;
        const d = new Date();
        d.setDate(d.getDate() + 1);
        while (saut < 14 && !ouvrable(d)) { d.setDate(d.getDate() + 1); saut += 1; }
        restant = (86400 - sec) + (saut - 1) * 86400 + tombee * 3600;
      }
      el.textContent = meme ? root.dataset.avant : root.dataset.apres;
      eh.textContent = deux(Math.floor(restant / 3600));
      em.textContent = deux(Math.floor((restant % 3600) / 60));
      es.textContent = deux(restant % 60);
      root.classList.toggle('bfm-bar--chaud', meme && restant <= 3600);
    };
    maj();
    // Le minuteur tournait même onglet masqué : batterie et CPU pour rien.
    let horloge = setInterval(maj, 1000);
    document.addEventListener('visibilitychange', () => {
      clearInterval(horloge);
      if (!document.hidden) { maj(); horloge = setInterval(maj, 1000); }
    });
  };
  const scan = () => document.querySelectorAll('.bfm-bar').forEach(init);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfm-grille-tuile"] && !Shopify.designMode) return;
  try {
    
(() => {
  const armer = (scroller) => {
    if (scroller.dataset.bfmPisteArme) return;
    scroller.dataset.bfmPisteArme = '1';
    const piste = scroller.closest('.bfm-gt__scroller-wrap')?.querySelector('[data-piste]');
    if (!piste) return;
    const maj = () => {
      // en desktop le scroller est en display:contents : il n'a pas de boîte, donc
      // scrollWidth et clientWidth valent 0 et 0/0 donnerait NaN%. On sort avant.
      const total = scroller.scrollWidth;
      const visible = scroller.clientWidth;
      if (!(total > 0) || !(visible > 0)) {
        piste.style.removeProperty('--piste-largeur');
        piste.style.removeProperty('transform');
        return;
      }
      const max = total - visible;
      const largeur = Math.min(100, (visible / total) * 100);
      piste.style.setProperty('--piste-largeur', largeur + '%');
      // translateX en % se calcule sur la largeur de la barre elle-même, pas sur
      // celle de la piste : on convertit la course voulue (100 - largeur, en % de
      // piste) vers cette base, sinon la barre n'atteint jamais le bout.
      const course = largeur > 0 ? ((100 - largeur) / largeur) * 100 : 0;
      const avance = max > 0 ? scroller.scrollLeft / max : 0;
      piste.style.transform = `translateX(${avance * course}%)`;
    };
    scroller.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  };
  const scan = () => document.querySelectorAll('.bfm-gt__scroller').forEach(armer);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfm-liens-collections"] && !Shopify.designMode) return;
  try {
    
(() => {
  const armer = (scroller) => {
    if (scroller.dataset.bfmPisteArme) return;
    scroller.dataset.bfmPisteArme = '1';
    const piste = scroller.closest('.bfm-lc__grid')?.querySelector('[data-piste]');
    if (!piste) return;
    const maj = () => {
      // en desktop le scroller est en display:contents : il n'a pas de boîte, donc
      // scrollWidth et clientWidth valent 0 et 0/0 donnerait NaN%. On sort avant.
      const total = scroller.scrollWidth;
      const visible = scroller.clientWidth;
      if (!(total > 0) || !(visible > 0)) {
        piste.style.removeProperty('--piste-largeur');
        piste.style.removeProperty('transform');
        return;
      }
      const max = total - visible;
      const largeur = Math.min(100, (visible / total) * 100);
      piste.style.setProperty('--piste-largeur', largeur + '%');
      // translateX en % se calcule sur la largeur de la barre elle-même, pas sur
      // celle de la piste : on convertit la course voulue (100 - largeur, en % de
      // piste) vers cette base, sinon la barre n'atteint jamais le bout.
      const course = largeur > 0 ? ((100 - largeur) / largeur) * 100 : 0;
      const avance = max > 0 ? scroller.scrollLeft / max : 0;
      piste.style.transform = `translateX(${avance * course}%)`;
    };
    scroller.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();
  };
  const scan = () => document.querySelectorAll('.bfm-lc__scroller').forEach(armer);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfm-panier-plus"] && !Shopify.designMode) return;
  try {
    
(() => {
  const recharge = () => window.location.reload();
  const init = () => {
    document.querySelectorAll('.bfm-pp__add:not([data-pret])').forEach((b) => {
      b.dataset.pret = '1';
      b.addEventListener('click', async () => {
        b.disabled = true;
        b.textContent = '…';
        try {
          await fetch('/cart/add.js', {method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: Number(b.dataset.var), quantity: 1}]})});
          recharge();
        } catch (e) { b.disabled = false; }
      });
    });
    const abo = document.querySelector('[data-bfm-pp-abo]:not([data-pret])');
    if (abo) {
      abo.dataset.pret = '1';
      abo.querySelector('[data-abo-go]').addEventListener('click', async (ev) => {
        const btn = ev.currentTarget;
        btn.disabled = true;
        const plan = abo.querySelector('[data-freq]').value;
        try {
          // retirer la ligne à l'unité, la remettre avec le plan
          await fetch('/cart/change.js', {method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: abo.dataset.cle, quantity: 0})});
          await fetch('/cart/add.js', {method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: Number(abo.dataset.var),
              quantity: Number(abo.dataset.qte), selling_plan: Number(plan)}]})});
          recharge();
        } catch (e) { btn.disabled = false; }
      });
    }
  };
  document.addEventListener('DOMContentLoaded', init);
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfm-pieces-achat"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.pret) return;
    root.dataset.pret = '1';
    const zone = root.querySelector('[data-erreur-zone]');

    root.addEventListener('change', (e) => {
      const sel = e.target.closest('[data-choix]');
      if (!sel || sel.tagName !== 'SELECT') return;
      const p = sel.closest('.bfm-pa__c').querySelector('[data-prix]');
      const opt = sel.options[sel.selectedIndex];
      if (p && opt && opt.dataset.prix) p.textContent = opt.dataset.prix;
    });

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-ajouter]');
      if (!btn) return;
      const carte = btn.closest('.bfm-pa__c');
      const choix = carte.querySelector('[data-choix]');
      if (!choix || !choix.value) return;
      if (zone) { zone.hidden = true; zone.textContent = ''; }
      btn.disabled = true;
      const texte = btn.textContent;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(choix.value), quantity: 1 }] }),
      })
        .then((r) => { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
        .then(() => {
          btn.textContent = 'Ajouté';
          btn.dataset.ok = '1';
          // on laisse le thème rafraîchir son panier s'il écoute
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
          setTimeout(() => {
            btn.textContent = texte;
            delete btn.dataset.ok;
            btn.disabled = false;
          }, 2200);
        })
        .catch(() => {
          btn.disabled = false;
          if (zone) {
            zone.textContent = root.dataset.erreur ||
              "L'ajout n'a pas pu être effectué. Vérifiez votre connexion, puis réessayez.";
            zone.hidden = false;
          }
        });
    });
  };
  const scan = () => document.querySelectorAll('.bfm-pa').forEach(init);
  document.addEventListener('DOMContentLoaded', scan);
  scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
